import { currentLang } from './i18n';
import { escapeHtml } from './html-escape';

function dismissToast(toast: HTMLElement) {
  if (toast.classList.contains('removing')) return;
  toast.classList.add('removing');
  const remove = () => toast.remove();
  toast.addEventListener('transitionend', remove, { once: true });
  window.setTimeout(remove, 200);
}

export function showToast(message: string, type: string = 'error', durationMs?: number) {
  const container = document.getElementById('toastContainer');
  const toast = document.createElement('div');
  toast.className = `toast toast-${type}`;
  toast.setAttribute('role', 'status');
  toast.setAttribute('aria-live', 'polite');
  toast.textContent = message;
  const duration = durationMs || Math.max(3000, Math.min(message.length * 80, 8000));
  container.appendChild(toast);
  const dismiss = () => dismissToast(toast);
  toast.addEventListener('click', dismiss);
  setTimeout(dismiss, duration);
}

export function showConfirmModal(message: string, actionLabel: string, onConfirm: () => void, icon: string = 'event') {
  document.querySelector('.confirm-modal')?.remove();
  const overlay = document.createElement('div');
  overlay.className = 'modal-overlay confirm-modal';
  overlay.innerHTML = `
    <div class="modal-content">
      <div class="modal-body">
        <div class="confirm-icon"><span class="mi">${escapeHtml(icon)}</span></div>
        <div class="confirm-msg">${escapeHtml(message)}</div>
        <div class="confirm-actions">
          <button class="confirm-cancel">${currentLang === 'en' ? 'No thanks' : 'そのまま'}</button>
          <button class="confirm-ok">${escapeHtml(actionLabel)}</button>
        </div>
      </div>
    </div>`;
  document.body.appendChild(overlay);
  const close = () => overlay.remove();
  overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
  overlay.querySelector('.confirm-cancel').addEventListener('click', close);
  overlay.querySelector('.confirm-ok').addEventListener('click', () => {
    close();
    onConfirm();
  });
}

export function showToastWithAction(message: string, actionLabel: string, onAction: () => void) {
  const container = document.getElementById('toastContainer');
  const toast = document.createElement('div');
  toast.className = 'toast toast-info toast-action';
  toast.setAttribute('role', 'status');
  toast.setAttribute('aria-live', 'polite');
  toast.innerHTML = `<span>${escapeHtml(message)}</span><button class="toast-action-btn">${escapeHtml(actionLabel)}</button>`;
  container.appendChild(toast);
  const dismiss = () => dismissToast(toast);
  toast.querySelector('.toast-action-btn').addEventListener('click', (e) => {
    e.stopPropagation();
    dismiss();
    onAction();
  });
  toast.addEventListener('click', dismiss);
  setTimeout(dismiss, 12000);
}
